/**
 * SABO Resort page motion. One IntersectionObserver.
 * The html.js-motion class is added from the document head before paint.
 */
(function () {
  if (!document.documentElement.classList.contains('js-motion')) return;
  if (!document.querySelector('[data-resort-page]')) return;

  var armed = new WeakSet();

  function ease(t) {
    var x1 = 0.22;
    var y1 = 1;
    var x2 = 0.36;
    var y2 = 1;
    var u = t;
    var i;
    for (i = 0; i < 6; i += 1) {
      var a = 1 - u;
      var x = 3 * a * a * u * x1 + 3 * a * u * u * x2 + u * u * u - t;
      var dx = 3 * a * a * x1 + 6 * a * u * (x2 - x1) + 3 * u * u * (1 - x2);
      if (Math.abs(dx) < 1e-6) break;
      u = Math.min(1, Math.max(0, u - x / dx));
    }
    var b = 1 - u;
    return 3 * b * b * u * y1 + 3 * b * u * u * y2 + u * u * u;
  }

  function formatMoney(amount, format) {
    var fixed = amount.toFixed(2);
    var whole = String(Math.round(amount));
    var comma = function (value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, comma(whole))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma(fixed))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, fixed.replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
        .replace(/\{\{\s*amount\s*\}\}/g, fixed);
    }
    return fixed;
  }

  function moneyFormat() {
    var node = document.querySelector('[data-resort-page-config]');
    if (!node) return '';
    try {
      var config = JSON.parse(node.textContent || '');
      return typeof config.moneyFormat === 'string' ? config.moneyFormat : '';
    } catch (error) {
      return '';
    }
  }

  function onFirstScreen(el) {
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) return false;
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function show(el) {
    el.classList.add('is-in');
    el.classList.remove('is-pending');
  }

  function dotShare(track) {
    var count = parseFloat(track.style.getPropertyValue('--track-count')) || 4;
    var index = parseFloat(track.style.getPropertyValue('--track-index')) || 0;
    var progress = parseFloat(track.style.getPropertyValue('--track-progress')) || 0;
    var segments = Math.max(1, count - 1);
    var fill = Math.max(0, (index + progress / 100) / segments);
    track.querySelectorAll('.sabo-resort__track-dot--filled').forEach(function (dot) {
      var step = dot.parentElement;
      var steps = step ? [...step.parentElement.children] : [];
      var at = steps.indexOf(step);
      var share = fill > 0 ? Math.min(1, (at / segments) / fill) : 0;
      dot.style.setProperty('--dot-share', String(share));
    });
  }

  function showSpend() {
    document.querySelectorAll('[data-resort-page] .sabo-resort-tiers__progress').forEach(function (node) {
      if (node instanceof HTMLElement) show(node);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (!(el instanceof HTMLElement)) return;
      if (el.dataset.motion === 'palm') {
        el.classList.toggle('is-playing', entry.isIntersecting);
        return;
      }
      if (!entry.isIntersecting) return;
      if (el.dataset.motion === 'track' && entry.intersectionRatio < 0.3) return;
      if (el.dataset.motion === 'track') {
        dotShare(el);
        window.setTimeout(showSpend, 1050);
      }
      show(el);
      observer.unobserve(el);
      if (el.dataset.motion === 'count') countUp(el);
    });
  }, {
    threshold: [0.15, 0.3]
  });

  function arm(el, options) {
    if (!(el instanceof HTMLElement) || armed.has(el) || el.closest('[hidden]')) return;
    armed.add(el);
    var kind = options.kind || 'reveal';
    el.dataset.motion = kind;
    if (typeof options.index === 'number') el.style.setProperty('--i', String(options.index));
    if (options.stagger) el.style.setProperty('--stagger', options.stagger);
    if (kind === 'palm') {
      observer.observe(el);
      return;
    }
    if (kind === 'spend') {
      if (!el.classList.contains('is-in')) el.classList.add('is-pending');
      return;
    }
    if (onFirstScreen(el)) {
      el.classList.add('is-static');
      show(el);
      if (kind === 'track') showSpend();
      if (kind === 'count') countUp(el);
      return;
    }
    el.classList.add('is-pending');
    observer.observe(el);
  }

  function countUp(el) {
    if (el.dataset.counted === 'true') return;
    el.dataset.counted = 'true';
    var label = el.getAttribute('data-label') || el.textContent || '';
    var target = parseFloat(el.getAttribute('data-amount') || '');
    if (!Number.isFinite(target) || target <= 0) {
      el.textContent = label;
      return;
    }
    var format = moneyFormat();
    var decimals = /\.\d/.test(label);
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / 700);
      if (t >= 1) {
        el.textContent = label;
        return;
      }
      var value = target * ease(t);
      el.textContent = formatMoney(decimals ? value : Math.round(value), format);
      window.requestAnimationFrame(frame);
    }
    el.textContent = formatMoney(0, format);
    window.requestAnimationFrame(frame);
  }

  function armStatic() {
    document.querySelectorAll(
      '.sabo-resort-intro .sabo-resort__heading, .sabo-resort-tiers__heading, .sabo-resort-details__heading, .sabo-resort-dash__title, .sabo-resort-earn__media, .sabo-resort-earn__copy, #faq .sabo-resort-faq__layout'
    ).forEach(function (el) {
      arm(el, { kind: 'reveal' });
    });
    document.querySelectorAll('[data-resort-page] .sabo-resort__tier-card').forEach(function (card, index) {
      arm(card, { kind: 'reveal', index: index, stagger: '60ms' });
    });
    document.querySelectorAll('[data-resort-page] .sabo-resort-dash__card').forEach(function (card, index) {
      arm(card, { kind: 'reveal', index: index, stagger: '80ms' });
    });
    document.querySelectorAll('[data-resort-page] .sabo-resort-tiers__progress').forEach(function (node) {
      arm(node, { kind: 'spend' });
    });
    arm(document.querySelector('[data-resort-page] .sabo-resort__track-steps'), { kind: 'track' });
    arm(document.querySelector('[data-resort-page] [data-resort-count]'), { kind: 'count' });
    arm(document.querySelector('[data-resort-page] .sabo-resort-earn__palm'), { kind: 'palm' });
  }

  document.querySelectorAll('.sabo-resort-faq__item').forEach(function (item) {
    var summary = item.querySelector('summary');
    var panel = item.querySelector('.sabo-resort-faq__panel');
    if (!(summary instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
    summary.addEventListener('click', function (event) {
      if (!document.documentElement.classList.contains('js-motion')) return;
      event.preventDefault();
      if (item.open) {
        item.classList.add('is-closing');
        panel.style.gridTemplateRows = '0fr';
        var finish = function (evt) {
          if (evt.propertyName !== 'grid-template-rows') return;
          panel.removeEventListener('transitionend', finish);
          item.open = false;
          item.classList.remove('is-closing');
          panel.style.gridTemplateRows = '';
        };
        panel.addEventListener('transitionend', finish);
        return;
      }
      item.open = true;
    });
  });

  armStatic();

  var updates = new MutationObserver(function () {
    armStatic();
  });
  var join = document.getElementById('join');
  if (join) {
    updates.observe(join, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function (event) {
    if (!event.matches) return;
    document.documentElement.classList.remove('js-motion');
    observer.disconnect();
    updates.disconnect();
  });
})();
